import { useTranslation } from "react-i18next";

const FEATURES = [
  { icon: "ri-star-line", titleKey: "feat.review.title", descKey: "feat.review.desc" },
  { icon: "ri-truck-line", titleKey: "feat.shipping.title", descKey: "feat.shipping.desc" },
  { icon: "ri-archive-line", titleKey: "feat.warehouse.title", descKey: "feat.warehouse.desc" },
  { icon: "ri-shield-check-line", titleKey: "feat.legit.title", descKey: "feat.legit.desc" },
  { icon: "ri-coupon-2-line", titleKey: "feat.coupon.title", descKey: "feat.coupon.desc" },
  { icon: "ri-percent-line", titleKey: "feat.discount.title", descKey: "feat.discount.desc" },
];

export default function Features() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold">
            {t("features.title")}
          </h2>
          <p className="mt-3 text-foreground-600">{t("features.subtitle")}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.titleKey}
              className="p-6 rounded-lg bg-background-100 border border-background-200 hover:border-secondary-300 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base md:text-lg font-heading font-semibold">
                {t(f.titleKey)}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {t(f.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}